<div class="position-relative">
  <div class="portal-example-page">
    <div class="portal-example-pager__content portal-example-pager__header-content--push">
      <div class="example-container mat-elevation-z8">
        <div class="example-header">
          <mat-tab-group #tabGroup mat-stretch-tabs="false">
            <!-- Person details -->
            <mat-tab label="Details">
              <div class="flex-layout fx-layout-row fx-align-start">
                @if (personDetailsForm) {
                <form [formGroup]="personDetailsForm">
                  @if (isBlocked) {
                  <span class="red-color-bold-label mb-2">BLOCKED</span>
                  }
                  @if (isAccountLocked) {
                  <div class="fx-layout-column">
                    <div class="float-right fx-layout-row fx-layout-xs-column">
                      <div class="fx-flex-50">
                      </div>
                      <div class="fx-flex-35 accountUnlockMessage">
                        <span>
                          Account Locked Until : {{ lockedUntil | date : 'medium' }}
                        </span>
                      </div>
                      <div class="fx-flex-10">
                        <button class="btn-width-200" mat-raised-button color="primary" (click)="unlockAccount()">
                          Unlock Account
                        </button>
                      </div>
                    </div>
                  </div>
                  } @else if (lockoutStateUnknown) {
                  <!--
                    JXP-1910: the lockout read above went to the legacy Zing identity server, which
                    does not hold this person's credential, so its answer is not evidence either
                    way. Say so instead of letting a missing Unlock button read as a healthy
                    account, and offer no Unlock action, which would act on the wrong record.
                  -->
                  @if (routesUnlockToAuth0) {
                  <div class="fx-layout-row fx-layout-xs-column">
                    <div class="fx-flex-50 alert alert-warning" role="alert">
                      <p class="m-0">
                        This person signs in through Auth0, where a lockout cannot be read here. Unlock Account
                        clears any Auth0 brute-force lockout.
                      </p>
                    </div>
                    <div class="fx-flex-10">
                      <button class="btn-width-200" mat-raised-button color="primary" (click)="unlockAccount()">
                        Unlock Account
                      </button>
                    </div>
                  </div>
                  } @else {
                  <div class="alert alert-warning" role="alert">
                    <p class="m-0">
                      Lockout state cannot be confirmed for {{ currentIdentityProviderDisplay }}. This person signs
                      in through {{ currentIdentityProviderDisplay }}, and unlocking here would only clear the legacy
                      Zing lockout.
                    </p>
                  </div>
                  }
                  }
                  @if (isAccountLocked || lockoutStateUnknown) {
                  <mat-divider class="my-3"></mat-divider>
                  }
                  <div class="fx-layout-row fx-layout-xs-column">
                    <mat-form-field>
                      <mat-label>First Name</mat-label>
                      <input matInput formControlName="firstName" type="text">
                      @if (hasError(firstNameCtrl)) {
                      <mat-error>
                        This is a required field.
                      </mat-error>
                      }
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Last Name</mat-label>
                      <input matInput formControlName="lastName" type="text">
                      @if (hasError(lastNameCtrl)) {
                      <mat-error>
                        This is a required field.
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="fx-layout-row fx-layout-xs-column">
                    <mat-form-field>
                      <mat-label>Middle Name</mat-label>
                      <input matInput formControlName="middleName" type="text">
                      @if (hasError(middleNameCtrl)) {
                      <mat-error>
                        This is a required field.
                      </mat-error>
                      }
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Company Id</mat-label>
                      <input matInput readonly formControlName="companyId" type="text">
                      @if (hasError(companyIdCtrl)) {
                      <mat-error>
                        This is a required field.
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="fx-layout-row fx-layout-xs-column">
                    <mat-form-field>
                      <mat-label>Approval Status</mat-label>
                      <mat-select formControlName="approvalStatus">
                        @for (status of approvalStatus | keys; track status) {
                        <mat-option [value]="status.key">{{ status.value |
                          approvalstatus }}
                        </mat-option>
                        }
                      </mat-select>
                      @if (hasError(approvalStatusCtrl)) {
                      <mat-error>
                        This is a required field.
                      </mat-error>
                      }
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Contact Preference</mat-label>
                      <mat-select formControlName="contactPreference">
                        @for (contact of contactPreferences | keys; track contact) {
                        <mat-option [value]="contact.key">{{
                          separateStringByUppercase(contact.value)
                          }}</mat-option>
                        }
                      </mat-select>
                      @if (hasError(contactPreferenceCtrl)) {
                      <mat-error>
                        This is a required field.
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="fx-layout-row fx-layout-xs-column">
                    <mat-form-field>
                      <mat-label>E-mail</mat-label>
                      <input matInput formControlName="email" type="text">
                      @if (hasErrorOfType('email', 'required')
                      || hasErrorOfType('email', 'pattern')
                      || hasErrorOfType('email', 'maxlength')) {
                      <mat-error>
                        Please enter valid email.
                      </mat-error>
                      }
                      @if (hasErrorOfType('email', 'emailInUse')) {
                      <mat-error>
                        Entered email address is duplicate.
                      </mat-error>
                      }
                      @if (!isInvite) {
                      <mat-checkbox class="verifyBox" formControlName="isEmailVerified">Verified
                      </mat-checkbox>
                      }
                      @if (hasError(isEmailVerifiedCtrl)) {
                      <mat-error>
                        This is a required field.
                      </mat-error>
                      }
                    </mat-form-field>
                    <mat-select formControlName="countryCode" id="countryCode" style="width:75px;"
                      hideSingleSelectionIndicator>
                      <mat-option value="+1">+1</mat-option>
                    </mat-select>
                    <mat-form-field style="width:90%">
                      <mat-label>Phone number</mat-label>
                      <input matInput formControlName="cellPhone" type="text"
                        [mask]="countryCodeCtrl.value | phonemask">
                      @if (hasErrorOfType('cellPhone', 'pattern')) {
                      <mat-error>
                        Enter a valid mobile number (Example: 1234567890)
                      </mat-error>
                      }
                      @if (!isInvite) {
                      <mat-checkbox class="verifyBox" formControlName="isCellPhoneVerified">Verified
                      </mat-checkbox>
                      }
                      @if (hasError(isCellPhoneVerifiedCtrl)) {
                      <mat-error>
                        This is a required field.
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  @if (person.newEmail || person.newPhoneNumber) {
                  <div class="fx-layout-row fx-layout-xs-column">
                    @if (person.newEmail) {
                    <mat-form-field class="fx-flex-50">
                      <mat-label>Email - Not verified</mat-label>
                      <input matInput formControlName="newEmail" type="text">
                    </mat-form-field>
                    }
                    @if (person.newPhoneNumber) {
                    <mat-form-field class="fx-flex-50">
                      <mat-label>Phone number - Not verified</mat-label>
                      <input matInput formControlName="newPhoneNumber" type="text">
                    </mat-form-field>
                    }
                  </div>
                  }
                  <div class="fx-layout-row fx-layout-xs-column">
                    <mat-form-field>
                      <mat-label>Add Skill</mat-label>
                      <mat-chip-grid #skillsChipList formControlName="skills">
                        @for (skill of skills; track skill) {
                        <mat-chip-row [removable]="removable" (removed)="removeSkill(skill)">
                          {{skill}}
                          @if (removable) {
                          <mat-icon matChipRemove>cancel</mat-icon>
                          }
                        </mat-chip-row>
                        }
                        <input [matChipInputFor]="skillsChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                          [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addSkill($event)">
                      </mat-chip-grid>
                    </mat-form-field>
                  </div>
                  <app-address [parent]="personDetailsForm" [address]="person.address" [requiredValidator]="false"
                    [isFormDisabled]="hasGuestRole"></app-address>
                  <div class="fx-layout-row fx-layout-xs-column">
                    <mat-form-field class="single">
                      <mat-label>Date joined</mat-label>
                      <input matInput formControlName="dateJoined" type="text">
                    </mat-form-field>
                    <mat-form-field class="single">
                      <mat-label>Last login date/time (CT)</mat-label>
                      <input matInput formControlName="lastLoginDate" type="text">
                    </mat-form-field>
                  </div>
                  @if (person.registrationId || (clientId && hasShipping)) {
                  <div class="fx-layout-row fx-layout-xs-column">
                    @if (person.registrationId) {
                    <mat-form-field class="single">
                      <mat-label>Registration ID</mat-label>
                      <input matInput formControlName="registrationId" type="text">
                    </mat-form-field>
                    }
                    @if (clientId && hasShipping) {
                    <mat-form-field class="single">
                      <mat-label>iShip Client ID</mat-label>
                      <input matInput formControlName="clientId" type="text">
                    </mat-form-field>
                    }
                  </div>
                  }
                  <div class="fx-layout-row fx-layout-xs-column">
                    <mat-form-field class="single">
                      <mat-label>Person registration source</mat-label>
                      <input matInput formControlName="personSource" type="text">
                    </mat-form-field>
                    @if (hasShipping) {
                      <mat-form-field class="single">
                        <mat-label>Shipping Terms and Conditions Acceptance Date</mat-label>
                        <input matInput formControlName="acceptedShippingDate" type="text">
                      </mat-form-field>
                    }
                  </div>
                  <div class="fx-layout-row fx-layout-xs-column">
                    <mat-form-field class="single">
                      <mat-label>Identity Provider</mat-label>
                      <input matInput formControlName="currentIdentityProvider" type="text">
                    </mat-form-field>
                  </div>
                  <div class="fx-layout-row fx-layout-xs-column">
                    <div class="fx-flex-10">
                      <mat-checkbox formControlName="isActive">Is Active</mat-checkbox>
                      @if (hasError(isActiveCtrl)) {
                      <mat-error>
                        This is a required field.
                      </mat-error>
                      }
                    </div>
                    <div class="fx-flex">
                      <mat-checkbox formControlName="disabledAnalytics">Disable Analytics</mat-checkbox>
                    </div>
                    <div class="fx-flex-50">
                      @if (isEditMode && hasShipping) {
                      <mat-checkbox [disabled]="true" formControlName="isShippingCustApproved">
                        Shipping Customer Approved on Core
                      </mat-checkbox>
                      }
                    </div>
                  </div>
                  <div class="mt-3 fx-layout-column">
                    <app-platform-roles [isSuperAdmin]="isSuperAdmin" [isPlatformAdmin]="isPlatformAdmin"
                      [personRoles]="person.roles" [roles]="platformUserRoles"
                      [disableOwnRoles]="disableOwnRoles || hasGuestRole" (roleSelected)="onRoleSelected($event)">
                    </app-platform-roles>
                  </div>
                  @if (person.companyId) {
                  <div class="mt-3 fx-layout-column">
                    <app-company-roles [personRoles]="person.roles" [person]="person" [roles]="companyUserRoles"
                      [disableOwnRoles]="disableOwnRoles || hasGuestRole" (roleSelected)="onRoleSelected($event)">
                    </app-company-roles>
                  </div>
                  }
                  @if (person.companyId) {
                  <div class="mt-3 fx-layout-column">
                    <h2 class="mt-3">Location User roles </h2>
                    @for (location of locations; track location) {
                    <app-location-roles [location]="location" [person]="person" [roles]="businessUserRoles"
                      [disableOwnRoles]="disableOwnRoles || hasGuestRole" (disableSaveButton)="disableButton = $event"
                      (makeFormDirty)="markFormAsDirty($event)">
                    </app-location-roles>
                    }
                  </div>
                  }
                  @if (betaExperienceFlag) {
                  <div class="mt-3">
                    <h2 class="mt-3">Experience / Rollout Flags</h2>
                    <div class="fx-layout-row fx-layout-xs-column">
                      <mat-form-field class="single">
                        <mat-label>New Zing</mat-label>
                        <input matInput readonly
                          [value]="betaExperienceFlag.effectiveValue ? 'In New Zing (opted in)' : (betaExperienceFlag.optedOut ? 'Opted out of New Zing' : 'No preference (Classic Zing)')">
                      </mat-form-field>
                    </div>
                    @if (betaExperienceFlag.lastModified) {
                    <div class="fx-layout-row fx-layout-xs-column">
                      <mat-form-field class="single">
                        <mat-label>Last Modified</mat-label>
                        <input matInput readonly [value]="betaExperienceFlag.lastModified | date:'medium'">
                      </mat-form-field>
                    </div>
                    }
                  </div>
                  }
                  <div class="footer">
                    <mat-card-actions align="end" class="fx-layout-row fx-layout-xs-column">
                      <button mat-raised-button color="primary" type="button" (click)="onBack()">Cancel</button>
                      @if (!isViewOnly) {
                      <button mat-raised-button color="primary" type="button"
                        [disabled]="personDetailsForm.invalid || !personDetailsForm.dirty || disableButton"
                        (click)="onSubmit()">Save</button>
                      }
                      @if ((person? isPersonNotRegistered(person) : false) && !hasGuestRole) {
                      <button mat-raised-button color="primary" type="button" (click)="inviteInactivePerson()">Save
                        and Invite</button>
                      }
                      @if ((person? isPersonReinvitable(person) : false) && !hasGuestRole) {
                      <button mat-raised-button color="primary" type="button" (click)="resendInvite()">Resend
                        Invite</button>
                      }
                    </mat-card-actions>
                  </div>
                </form>
                }
              </div>
            </mat-tab>
            @if (isEditMode && person.referenceId && !hasGuestRole && !isRegulatoryComplianceAdmin) {
            <mat-tab label="Identity">
              <app-person-identity [person]="person">
              </app-person-identity>
            </mat-tab>
            }
            @if (canEditServicePermissions && !hasGuestRole) {
            <mat-tab label="Service Permissions">
              @if ((isSuperOrPlatformAdmin || isShippingAdmin || isPartnerGatewayAdmin) && hasShipping) {
              <app-shipment-permissions [person]="person">
              </app-shipment-permissions>
              }
              @if ((isSuperOrPlatformAdmin || isCLAdmin) && hasCL) {
              <app-commercial-lines-permission>
              </app-commercial-lines-permission>
              }
              @if (hasPersonalInsurance && hasPersonalInsurancePermissions) {
              <app-personal-insurance-permission [person]="person">
              </app-personal-insurance-permission>
              }
              @if (hasMarketplace && hasMarketplacePermissions) {
              <app-marketplace-permission [person]="person">
              </app-marketplace-permission>
              }
              @if ((isSuperOrPlatformAdmin || isPartnerGatewayAdmin) && hasPG) {
              <app-partner-gateway-permission [person]="person" [subscription]="JMPGSubscription">
              </app-partner-gateway-permission>
              }
              @if (hasAppraisal && hasAppraisalPermissions) {
              <app-appraisal-permission [person]="person">
              </app-appraisal-permission>
              }
              @if (hasJewelerPages && hasJewelerPagesPermissions) {
              <app-jeweler-pages-permission [person]="person">
              </app-jeweler-pages-permission>
              }
              @if (showAuctionPermissionPanel) {
              <app-auction-permission (updatedPermission)="onUpdatedAuctionPermission($event)" [person]="person">
              </app-auction-permission>
              }
            </mat-tab>
            }

            @if (person?.id && (isSuperOrPlatformAdmin || isRegulatoryComplianceAdmin || isMembershipAdmin)) {
            <mat-tab label="OFAC History" [disabled]="!isEditMode">
              @if (person.approvalStatus === approvalStatus.Blocked) {
              <div class="alert alert-warning d-flex justify-content-between align-items-center" role="alert">
                <p class="m-0">For unblocking , please contact Regulatory Compliance and Platform Administrator</p>
              </div>
              }
              <p class="portal-top-text">View screening matches</p>
              <app-screening-results-table [screeningFilter]="getScreeningFilter()" [disableActions]="true"
                [hideEntityDetails]="true" sortBy="createdOn" [person]="person" [companyName]="company?.name"
                [hideInitiateButton]="isBlocked"></app-screening-results-table>
            </mat-tab>
            }
          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>

  <app-in-progress [loading]="loadingData"> </app-in-progress>